export default {
  props: {
    locationId: Number,
  },
  data () {
    return {
      FLOATING_BOX_SIZE: 30,
      CANVAS_WIDTH: 1000,
      CANVAS_HEIGHT: 600,
      linkIcon: {},
      customIconsMap: {},
      arrowIconsMap: {},
      statusIcons: [],
      statusIconsMap: {},
      statusIconOptionsMap: {},
      tableImages: [],
      tableImagesMap: {},
      floatingBoxPositions: [],
      floatingBoxPositionsMap: {},
      locationTables: [],
      locationTablesMap: {},
      borderCoordinates: {
        'T_B': {height: 130, width: 100, offsetX: 50, offsetY: 65},
        'L_R': {height: 100, width: 130, offsetX: 65, offsetY: 50},
        'TOP': {height: 110, width: 100, offsetX: 50, offsetY: 70},
        'BOTTOM': {height: 110, width: 100, offsetX: 50, offsetY: 40},
        'LEFT': {height: 100, width: 110, offsetX: 70, offsetY: 50},
        'RIGHT': {height: 100, width: 110, offsetX: 40, offsetY: 50}
      },

      loadingImages: 2,
      fontsList: [
        {text: 'Arial', value: 'Arial'},
        {text: 'Arial Narrow', value: 'Arial narrow'},
        {text: 'Times New Roman', value: 'Times New Roman'},
        {text: 'Tahoma', value: 'Tahoma'},
        {text: 'Optima', value: 'Optima'},
        {text: 'Papyrus', value: 'papyrus'},
        {text: 'Comic Sans MS', value: 'Comic Sans MS'},
        {text: 'Chalk Duster', value: 'Chalkduster'},
      ],
      iconsList: [
        {text: 'Star', value: 'star-plus.png'},
        {text: 'Flower', value: 'flower.png'},
        {text: 'Tulip', value: 'flower-tulip.png'},
        {text: 'Pine Tree', value: 'pine-tree.png'},
        {text: 'Sprout', value: 'sprout.png'},
        {text: 'Door Closed', value: 'door-closed.png'},
        {text: 'Sliding Door', value: 'door-sliding.png'},
        {text: 'Open Sliding Door', value: 'door-sliding-open.png'},
        {text: 'Lamp', value: 'lamp.png'},
        {text: 'Floor Lamp', value: 'floor-lamp.png'},
        {text: 'Television', value: 'television.png'},
        {text: 'POS Printer', value: 'printer-pos.png'},
        {text: 'Toilet', value: 'toilet.png'},
        {text: 'Faucet', value: 'faucet-variant.png'},
        {text: 'Grill', value: 'grill.png'},
        {text: 'Wine Glass', value: 'glass-wine.png'},
        {text: 'Pint Glass', value: 'beer.png'},
        {text: 'Mug', value: 'glass-mug-variant.png'},
        {text: 'Emergency Exit', value: 'exit-run-custom.png'},
        {text: 'Fireplace', value: 'fireplace.png'},
        {text: 'Campfire', value: 'campfire.png'},
        {text: 'Sofa', value: 'sofa-single.png'},
        {text: 'Bench', value: 'bench.png'},
        {text: 'Fountain', value: 'fountain.png'},
        {text: 'Chef Hat', value: 'chef-hat.png'},
        {text: 'Stove', value: 'stove.png'},
        {text: 'Playing Cards', value: 'cards-playing-spade-multiple-outline.png'},
        {text: 'Umbrella', value: 'umbrella-beach.png'},
        {text: 'Tower', value: 'tower-beach.png'},
        {text: 'Golf', value: 'golf.png'},
        {text: 'Tennis', value: 'tennis.png'},
        {text: 'Dumbbell', value: 'dumbbell.png'},
        {text: 'Swim', value: 'swim.png'},
        {text: 'No Phones', value: 'cellphone-off.png'},
        {text: 'Stool', value: 'stool.png'},
        {text: 'Wheelchair', value: 'wheelchair.png'},
        {text: 'Stairs', value: 'stairs-box.png'},
      ],
      arrowIconsList: [
        {text: 'Arrow Up', value: 'arrow-up.png'},
        {text: 'Arrow Up/Down', value: 'arrow-up-down.png'},
        {text: 'Arrow Up Circle', value: 'arrow-up-circle-outline.png'}
      ]
    }
  },
  computed: {
    fontsMap () {
      return this.fontsList.reduce((acc, r) => {
        acc[r.value] = r.text
        return acc
      }, {})
    },
    iconNamesMap () {
      return this.iconsList.reduce((acc, r) => {
        acc[r.value] = r.text
        return acc
      }, {})
    },
    arrowIconNamesMap () {
      return this.arrowIconsList.reduce((acc, r) => {
        acc[r.value] = r.text
        return acc
      }, {})
    }
  },
  mounted () {
    import('@/ft-vue-core/images/floorPlan/customIcons/black/content-save-alert.png').then(r => {
      let img = new Image()
      img.onload = () => this.$set(this.statusIcons, 'alert', img)
      img.src = r.default
    })
    const commands = [
      {
        command: 'apiFieldOption',
        load: this.statusIcons,
        afterLoad (r) {
          this.loadingImages -= 1
          for (let option of r) this.mapStatusIcon(option.value, option.extData, 'black')
          for (let option of r) this.mapStatusIcon(option.value, option.extData, 'white')
          this.statusIconOptionsMap = this.statusIcons.reduce((acc, s) => {
            acc[s.value] = s
            return acc
          }, {}) ?? {}
        },
        params: {filter_methods: {forField: ['diningLocationTable', 'status']}}
      },
      {
        command: 'apiFieldOption',
        load: this.tableImages,
        afterLoad (r) {
          this.loadingImages -= 1
          for (let option of r) this.mapTableImage(option.value, option.extData)
        },
        params: {filter_methods: {forField: ['diningTableConfigurationDetail', 'shape']}}
      },
      {
        command: 'apiFieldOption',
        load: this.floatingBoxPositions,
        afterLoad (r) {
          this.floatingBoxPositionsMap = r.reduce((acc, r) => {
            acc[r.value] = r
            return acc
          }, {}) ?? {}
        },
        params: {filter_methods: {forField: ['diningTableConfigurationDetail', 'floatingBoxPosition']}}
      }
    ]
    this.$ftAPI().get(commands)
    import('@/ft-vue-core/images/floorPlan/link-variant.png').then(r => {
      let img = new Image()
      img.onload = () => this.$set(this, 'linkIcon', img)
      img.src = r.default
    })
    for (const color of ['black', 'white']) {
      for (const pngIcon of this.iconsList) {
        import(`@/ft-vue-core/images/floorPlan/customIcons/${color}/${pngIcon.value}`).then(r => {
          let img = new Image()
          img.onload = () => {this.$set(this.customIconsMap, `${color}-${pngIcon.value}`, img)}
          img.src = r.default
        })
      }
      for (const pngIcon of this.arrowIconsList) {
        import(`@/ft-vue-core/images/floorPlan/arrowIcons/${color}/${pngIcon.value}`).then(r => {
          let img = new Image()
          img.onload = () => {this.$set(this.arrowIconsMap, `${color}-${pngIcon.value}`, img)}
          img.src = r.default
        })
      }
    }
    this.buildLocationTableMap(this.locationId)
  },
  watch: {
    locationId (value) {
      if (!value) return
      this.buildLocationTableMap(value)
    },
    loadingImages (newVal) {
      if (newVal) return
      for (let status of this.statusIcons) {
        const {color} = status?.extData ?? {}
        for (let shape of this.tableImages) {
          const {image} = shape.extData
          this.mapTableImage(`${color.toUpperCase().replace('-', '_')}_${shape.value}`, {image: `${color}/${color}-${image}`})
        }
      }
    }
  },
  methods: {
    /**
     * Build a Map of `DiningLocationTable` records at the `locationId` passed in
     * @param {Number} locationId 
     */
    buildLocationTableMap (locationId) {
      if (!locationId) return
      this.$ftAPI().get({
        command: 'diningLocationTable',
        afterLoad (e) {
          this.locationTablesMap = e?.reduce((acc, r) => {
            if (this.excludeStatus) r.status = null
            acc[r.id] = r
            return acc
          }, {}) ?? {}
          this.locationTables = Object.values(this.locationTablesMap)
        },
        params: {
          children: true,
          filter_methods: {
            filterLocation: [locationId],
            // TODO can use this to add additional features later
            // Temporarily defaulting to auto-clear
            // FIXME need to load `autoClearReservationStatus` _before_ we get here
            // userMostRecentStatus[!this.autoClearReservationStatus]
            useMostRecentStatus: [false]
          }
        }
      })
    },
    async mapStatusIcon (value, {pngIcon}, color) {
      import(`@/ft-vue-core/images/floorPlan/statusIcons/${color}/${pngIcon}`).then(r => {
        let img = new Image()
        img.onload = () => this.$set(this.statusIconsMap, `${color.toUpperCase()}_${value}`, img)
        img.src = r.default
      })
    },
    async mapTableImage (value, {image}) {
      if (!image) return
      import(`@/ft-vue-core/images/floorPlan/tables/${image}`).then(r => {
        let img = new Image()
        img.onload = () => this.$set(this.tableImagesMap, value, img)
        img.src = r.default
      })
    },
    getLinkPoints (hoveredTables = []) {
      if (hoveredTables.length <= 1) return
      else if (hoveredTables.length === 2) {
        const [t1, t2] = hoveredTables
        return [{points: [t1.x, t1.y, t2.x, t2.y]}]
      }
      const checkTriangulation = (graph = {}, obj = {}) => {
        return graph[obj.to]?.to && graph[graph[obj.to].to]?.to === obj.from
      }
      let graph = {}
      return hoveredTables.reduce((acc1, t1) => {
        let edges = new Array()
        do {
          let minIndex = -1
          let minLength = hoveredTables.reduce((acc2, t2, index) => {
            if (t2.id === t1.id || edges[0]?.to === t2.id) return acc2
            const length = Math.sqrt(Math.pow(t2.x - t1.x, 2) + Math.pow(t2.y - t1.y, 2))
            if (acc2 === -1 || length < acc2) acc2 = length, minIndex = index
            return acc2
          }, -1)
          if (minIndex !== -1) edges.push({
            tableName: t1.tableName,
            from: t1.id,
            to: hoveredTables[minIndex].id,
            points: [t1.x, t1.y, hoveredTables[minIndex].x, hoveredTables[minIndex].y],
            length: minLength
          })
        } while (edges.length < 2)
        let [shortest, backup] = edges
        if (graph[shortest.to]?.to === t1.id) {
          if (checkTriangulation(graph, backup)) return acc1
          graph[t1.id] = backup
        }
        else if (checkTriangulation(graph, shortest)) return acc1
        else graph[t1.id] = shortest
        acc1.push(graph[t1.id])
        return acc1
      }, []) ?? []
    },
    getColorTable (table = {}, shape = 'SQUARE_4') {
      if (table.status) {
        const {color} = this.statusIconOptionsMap[table.status]?.extData ?? {}
        const key = `${color?.toUpperCase().replace('-', '_') ?? 'BLACK'}_${shape}` 
        return this.tableImagesMap[key]
      }
      return this.tableImagesMap[shape]
    },
    getTableFillColor (table = {}) {
      if (table.status) {
        const {fillColor} = this.statusIconOptionsMap[table.status]?.extData ?? {}
        return fillColor || 'grey'
      }
      return 'grey'
    },
    getTableTextColor (table = {}) {
      if (table.status) {
        const {textColor} = this.statusIconOptionsMap[table.status]?.extData ?? {}
        return textColor || 'black'
      }
      return 'black'
    },
    getStatusIcon (table = {}) {
      return this.statusIconsMap[`${this.getTableTextColor(table, status).toUpperCase()}_${table.status}`]
    },
    getOffsetX (table, index) {
      const {floatingBoxPosition, scaleX} = table ?? {}
      const {offsetX} = this.floatingBoxPositionsMap[floatingBoxPosition]?.extData ?? {}
      let [result, subtrahend] = [offsetX?.[index] ?? 0, 0]
      if (index === 0 && ['TOP', 'BOTTOM', 'LEFT', 'L_R'].includes(floatingBoxPosition)
        || index === 1 && 'LEFT' === floatingBoxPosition
      ) subtrahend = (1 - 1 / scaleX) * this.FLOATING_BOX_SIZE
      else if (floatingBoxPosition === 'T_B') subtrahend = (1 - 1 / scaleX) * this.FLOATING_BOX_SIZE / 2
      return result - subtrahend || 0
    },
    getOffsetY (table, index) {
      const {floatingBoxPosition, scaleY} = table ?? {}
      const {offsetY} = this.floatingBoxPositionsMap[floatingBoxPosition]?.extData ?? {}
      let [result, subtrahend] = [offsetY?.[index] ?? 0, 0]
      if (index === 0 && ['RIGHT', 'TOP', 'LEFT', 'T_B'].includes(floatingBoxPosition)
        || index === 1 && 'TOP' === floatingBoxPosition
      ) subtrahend = (1 - 1 / scaleY) * this.FLOATING_BOX_SIZE
      else if (floatingBoxPosition === 'L_R') subtrahend = (1 - 1 / scaleY) * this.FLOATING_BOX_SIZE / 2 
      return result - subtrahend || 0
    },
    getBorderDimensions (table) {
      return this.borderCoordinates[table?.floatingBoxPosition ?? 'L_R']
    },
    getTextBackgroundSize (table, lines = 2) {
      const ref = this.$refs[table.name + '-text']?.[0]?.getNode?.() || {}
      const [textWidth, textHeight] = [ref?.textWidth ?? 0, ref?.textHeight ?? 0]
      const [height, width] = [Math.min(textHeight * lines + 5, 100), Math.min(textWidth + 5, 100)]
      return {height, width, offsetX: width / 2, offsetY: height / 2}
    },
  }
}